<template>
  <div class="dashboard-box">
    <div class="dashboard-context">
      <div class="share-total">
        <div class="share-jobs">
          <!-- <span class="number">{{ dashboardData.jobShares }}</span>
          <span>{{ $t('personal.referrals.dashboard.label.jobShares') }}</span> -->
          <span class="number">{{ dashboardData.pageViews }}</span>
          <span>{{ $t('personal.referrals.dashboard.label.pageViews') }}</span>
          <div class="status-box">
            <span>{{ $t('personal.referrals.dashboard.potentialStatus.leads') }}</span>
            <!-- <span>{{ $t('personal.referrals.dashboard.potentialStatus.prospects') }}</span> -->
            <span>{{ $t('personal.referrals.dashboard.potentialStatus.submitReferrals') }}</span>
          </div>
        </div>
        <div class="page-views">
          <!-- <span class="number">{{ dashboardData.pageViews }}</span>
          <span>{{ $t('personal.referrals.dashboard.label.pageViews') }}</span> -->
          <div class="status-number">
            <div class="status-number-and-arrow" @click="toLeadsPage">
              <span class="type-number">{{ dashboardData.leadsCount }}</span>
              <span><i class="el-icon-arrow-right"></i></span>
            </div>
            <!-- <div class="status-number-and-arrow" @click="toLeadsPage">
              <span class="type-number">{{ dashboardData.prospects }}</span>
              <span><i class="el-icon-arrow-right"></i></span>
            </div> -->
            <div class="status-number-and-arrow" @click="toAppliedPage">
              <span class="type-number">{{ dashboardData.submitReferralCount }}</span>
              <span><i class="el-icon-arrow-right"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="referrals-box" @click="toAppliedPage">
        <span class="referral-title">
          {{ $t('personal.referrals.dashboard.label.referrals') }}
        </span>
        <span class="referral-title-arrow">
          <i class="el-icon-arrow-right"></i>
        </span>
      </div>
      <div class="referrals-info">
        <div class="referrals-status-count">
          <div v-for="(statusGroup, index) in dashboardData.statusGroupList" :key="index">
            <span class="type-text">{{ $t(`admin.application.candidate.STATUS_GROUP.${statusGroup.name}`) }}</span>
            <span class="type-number">{{ statusGroup.count || 0 }}</span>
          </div>
        </div>
        <div class="referrals-help">
          <div class="refer-button-box">
            <span class="iconfont">&#xe65a;</span>
            <span @click="toCompanyJobList">{{ $t('personal.referrals.dashboard.label.referJobs') }}</span>
          </div>
          <div v-if="showReferralRule" class="refer-button-box">
            <span class="iconfont">&#xe662;</span>
            <span @click="toReferralRulePage">{{ $t('personal.referrals.dashboard.label.referRules') }}</span>
          </div>
          <div class="refer-button-box">
            <span class="iconfont">&#xe65c;</span>
            <span>{{ $t('personal.referrals.dashboard.label.referFAQ') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as referralsRoute from '../referralsRoute'
import { mapActions } from 'vuex'

export default {
  props: {
    personalInfo: {
      required: true
    }
  },
  components: {

  },
  data () {
    return {
      dashboardData: {
        leadsCount: 0,
        submitReferralCount: 0,
        jobShares: 0,
        pageViews: 0,
        prospects: 0,
        statusGroupList: []
      }
    }
  },
  created () {
    this.initData()
  },
  computed: {
    leadsRoute () {
      return referralsRoute.leadsRoute
    },
    appliedRoute () {
      return referralsRoute.leadsRoute.children[1]
    },
    referralRulesUrl () {
      return this.$DjangoBaseUrl('/referral/about-program/')
    },
    showReferralRule () {
      const companyId = this.personalInfo.employee?.company.root_company.id
      return companyId !== 12600
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions('personal', ['getMyDashboardData']),
    async initData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getMyDashboardData()
        if (resp) {
          this.dashboardData = resp
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    toReferralRulePage () {
      window.location.href = this.referralRulesUrl
    },
    toLeadsPage () {
      this.$router.push({ path: this.leadsRoute.path, query: this.$route.query })
    },
    toAppliedPage () {
      this.$router.push({ path: this.appliedRoute.path, query: this.$route.query })
    },
    toCompanyJobList () {
      if (this.personalInfo?.employee) {
        window.location.href = this.companyJobListUrl(this.personalInfo.employee.company.id)
      } else {
        window.location.href = this.$DjangoBaseUrl('/jobseekers/')
      }
    },
    companyJobListUrl (companyId) {
      return this.$DjangoBaseUrl(`/mobile-web-more-jobs/${companyId}/`)
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.dashboard-box {

  .dashboard-context {
    background-color: #FFFFFF;
    margin-top: 10px;
    border-radius: 5px;
    padding: 10px;

    .share-total {
      display: flex;
      padding: 20px;
      justify-content: space-between;

      .page-views {
        justify-content: flex-end;
      }

      span {
        color: #666666;
      }

      > div {
        flex: 1;
        display: flex;
        align-items: flex-start;
        padding: 0 0 0 10px;
        flex-direction: column;
      }

      .number {
        color: #333333;
        font-size: 40px;
      }

      .status-box {
        margin: 40px 0 20px 0;
        display: flex;
        flex-direction: column;

        > span {
          margin: 10px 0 5px 0;
          line-height: 20px;
        }
      }

      .status-number {
        margin: 40px 0 20px 0;
        display: flex;
        flex-direction: column;

        > div {
          margin: 10px 0 5px 0;
          line-height: 20px;
        }
      }

      .status-number-and-arrow {
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        color: #0096cc;

        .type-number {
          width: auto;
          color: #0096cc;
        }
      }
    }

    .referrals-box {
      display: flex;
      align-items: center;
      padding: 20px 20px 15px 20px;
      border-bottom: 1px solid #c3c3c3;
      cursor: pointer;

      .referral-title {
        padding: 0 0 0 10px;
        font-size: 24px;
        color: #0096cc;
      }

      .referral-title-arrow {
        margin-left: 10px;

        > i {
          color: #0096cc;
          opacity: 0.8;
          font-size: 26px;
        }
      }
    }

    .referrals-info {
      display: flex;
      padding: 20px;

      .referrals-status-count {
        flex: 1;
        padding: 0 0 0 10px;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        span {
          color: #666666;
        }

        > div {
          display: flex;
          justify-content: space-between;
          width: 60%;
        }
      }

      .referrals-help {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .refer-button-box {
          display: flex;
          align-items: center;

          span {
            color: #0096cc;
            cursor: pointer;
          }

          .iconfont {
            font-size: 28px;
            margin: 0 10px 0 0;
            cursor: default;
          }
        }
      }
    }

    .type-number {
      width: 10%;
      font-size: 16px;
    }
  }

  .el-icon-arrow-right {
    color: #0096cc;
    margin-left: 5px;
  }
}
</style>
